//
// @see https://docs.google.com/document/d/17nwNCVs3FFDWnAu0HBc5jlOmKriNkQCc2Ojh1zDXHds/edit
//
// The basic structure of a Block should take the form { type: string; value: any }. Additionally, ensure that it scales based on the type.
//
import * as z from "zod";
import { Carousel } from "./Carousel";
import { CumulativeLayoutShift } from "./CumulativeLayoutShift";
import { Divider } from "./Divider";
import { Header } from "./Header";
import { ImageInputOutputExpected } from "./ImageInputOutputExpected";
import { Markdown } from "./Markdown";
import { Stepper } from "./Stepper";
import { Table } from "./Table";
import { TableDiff } from "./TableDiff";
import { TestCaseResult } from "./TestCaseResult";
import { TextDiffViewer } from "./TextDiffViewer";
export const Block = z.union([
    Carousel,
    CumulativeLayoutShift,
    Divider,
    Header,
    Markdown,
    Stepper,
    Table,
    TableDiff,
    TestCaseResult,
    TextDiffViewer,
    ImageInputOutputExpected,
]);
